// 全角を半角に変換
module.exports.zen_to_han = function( str ) {
  var regex = /[Ａ-Ｚａ-ｚ０-９！＂＃＄％＆＇（）＊＋，－．／：；＜＝＞？＠［＼］＾＿｀｛｜｝]/g;
  return str
		.replace( regex, function( match ) {
			return String.fromCharCode( match.charCodeAt( 0 ) - 0xfee0 );
		})
		.replace( /[‐－―]/g, '-' )
		.replace( /[～〜]/g, '~' );
}

// カタカナをひらがなに変換
module.exports.kana_to_hira = function( str ) {
	str = hankana_top_zenkana( str );
	return str.replace( /[\u30a1-\u30f6]/g, function( match ) {
		return String.fromCharCode( match.charCodeAt( 0 ) - 0x60 );
	});
}

// ひらがなをカタカナに変換
module.exports.hira_to_kana = function( str ) {
	str = hankana_top_zenkana( str );
	return str.replace( /[\u3041-\u3096]/g, function( match ) {
		return String.fromCharCode( match.charCodeAt( 0 ) + 0x60 );
	});
}

// 半角カタカナを全角カタカナに変換
module.exports.hankana_top_zenkana = function( str ) {
	var map = {
		'ｶﾞ': 'ガ', 'ｷﾞ': 'ギ', 'ｸﾞ': 'グ', 'ｹﾞ': 'ゲ', 'ｺﾞ': 'ゴ',
		'ｻﾞ': 'ザ', 'ｼﾞ': 'ジ', 'ｽﾞ': 'ズ', 'ｾﾞ': 'ゼ', 'ｿﾞ': 'ゾ',
		'ﾀﾞ': 'ダ', 'ﾁﾞ': 'ヂ', 'ﾂﾞ': 'ヅ', 'ﾃﾞ': 'デ', 'ﾄﾞ': 'ド',
		'ﾊﾞ': 'バ', 'ﾋﾞ': 'ビ', 'ﾌﾞ': 'ブ', 'ﾍﾞ': 'ベ', 'ﾎﾞ': 'ボ',
		'ﾊﾟ': 'パ', 'ﾋﾟ': 'ピ', 'ﾌﾟ': 'プ', 'ﾍﾟ': 'ペ', 'ﾎﾟ': 'ポ',
		'ｳﾞ': 'ヴ', 'ﾜﾞ': 'ヷ', 'ｦﾞ': 'ヺ',
		'ｱ': 'ア', 'ｲ': 'イ', 'ｳ': 'ウ', 'ｴ': 'エ', 'ｵ': 'オ',
		'ｶ': 'カ', 'ｷ': 'キ', 'ｸ': 'ク', 'ｹ': 'ケ', 'ｺ': 'コ',
		'ｻ': 'サ', 'ｼ': 'シ', 'ｽ': 'ス', 'ｾ': 'セ', 'ｿ': 'ソ',
		'ﾀ': 'タ', 'ﾁ': 'チ', 'ﾂ': 'ツ', 'ﾃ': 'テ', 'ﾄ': 'ト',
		'ﾅ': 'ナ', 'ﾆ': 'ニ', 'ﾇ': 'ヌ', 'ﾈ': 'ネ', 'ﾉ': 'ノ',
		'ﾊ': 'ハ', 'ﾋ': 'ヒ', 'ﾌ': 'フ', 'ﾍ': 'ヘ', 'ﾎ': 'ホ',
		'ﾏ': 'マ', 'ﾐ': 'ミ', 'ﾑ': 'ム', 'ﾒ': 'メ', 'ﾓ': 'モ',
		'ﾔ': 'ヤ', 'ﾕ': 'ユ', 'ﾖ': 'ヨ',
		'ﾗ': 'ラ', 'ﾘ': 'リ', 'ﾙ': 'ル', 'ﾚ': 'レ', 'ﾛ': 'ロ',
		'ﾜ': 'ワ', 'ｦ': 'ヲ', 'ﾝ': 'ン',
		'ｧ': 'ァ', 'ｨ': 'ィ', 'ｩ': 'ゥ', 'ｪ': 'ェ', 'ｫ': 'ォ',
		'ｯ': 'ッ', 'ｬ': 'ャ', 'ｭ': 'ュ', 'ｮ': 'ョ',
		'｡': '。', '､': '、', 'ｰ': 'ー', '｢': '「', '｣': '」', '･': '・'
	};

	var regex = new RegExp( '(' + Object.keys( map ).join( '|' ) + ')', 'g' );
	return str
		.replace( regex, function( match ) {
				return map[match];
		})
		.replace( /ﾞ/g, '゛' )
		.replace( /ﾟ/g, '゜' );
};

// 形式チェック（ひらがな）
module.exports.is_hira = function( str ) {
  return str.match( /^[\u3040-\u309f]+$/ );
}

// 形式チェック（カタカナ）
module.exports.is_kana = function( str ) {
  return str.match( /^[\u30a0-\u30ff]+$/ );
}

// 形式チェック（電話番号）
module.exports.is_tel = function( tel ) {
	tel = tel.replace( /-/g, '' );
	if ( tel.match( /^0[789]0/ ) ) {
		return /^0[789]0[0-9]{8}$/.test( tel );
	} else {
		return /^0\d{9}$/.test( tel );
	}
}

// 形式チェック（メールアドレス）
module.exports.is_email = function( email ) {
	return /^([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x22([^\x0d\x22\x5c\x80-\xff]|\x5c[\x00-\x7f])*\x22)(\x2e([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x22([^\x0d\x22\x5c\x80-\xff]|\x5c[\x00-\x7f])*\x22))*\x40([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x5b([^\x0d\x5b-\x5d\x80-\xff]|\x5c[\x00-\x7f])*\x5d)(\x2e([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x5b([^\x0d\x5b-\x5d\x80-\xff]|\x5c[\x00-\x7f])*\x5d))*$/.test( email );
}


// 形式チェック（携帯番号）
module.exports.is_mobile_tel = function( tel ) {
	tel = tel.replace( /-/g, '' );
	if ( ! tel.match( /(.)\1{4,}/ ) ) {
		if ( tel.match( /^0[789]0/ ) ) {
			return /^0[789]0[0-9]{8}$/.test( tel ) && ! /^08012345678$/.test( tel );
		} else {
			return false;
		}
	} else {
		return false;
	}
}

// 形式チェック（メールアドレス）
module.exports.isEmail = function( email ) {
	var emailSplit = email.split( '@' );

	return /^([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x22([^\x0d\x22\x5c\x80-\xff]|\x5c[\x00-\x7f])*\x22)(\x2e([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x22([^\x0d\x22\x5c\x80-\xff]|\x5c[\x00-\x7f])*\x22))*\x40([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x5b([^\x0d\x5b-\x5d\x80-\xff]|\x5c[\x00-\x7f])*\x5d)(\x2e([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x5b([^\x0d\x5b-\x5d\x80-\xff]|\x5c[\x00-\x7f])*\x5d))*$/.test( email ) && emailSplit[0].length > 1;
}

// 形式チェック（URL）
module.exports.isUrl = function( url ) {
	return /^(https?|ftp)(:\/\/[-_.!~*\'()a-zA-Z0-9;\/?:\@&=+\$,%#]+)$/.test( url );
}



//////////////////
// WEBPACK FOOTER
// ./assets/javascripts/function.js
// module id = 3
// module chunks = 0